import React, {useState} from 'react';
import {Accordion} from 'react-bootstrap';
import {AccordionEventKey} from 'react-bootstrap/esm/AccordionContext';
import Header from '../../../components/header';
import FaqItem from '../../../module/profile/faqItem';

const Faqs: Array<IFaq> = [
  {
    title: 'چطور می‌توانم کالا یا خدمتی را در فروشگاه مزرعه عرضه یا تهیه کنم؟',
    description: `با ثبت یا جستجوی آگهی در فروشگاه مزرعه می‌توانید در معرض دید هزاران کشاورز و فروشگاه قرار گیرید و با آنها
تعامل داشته باشید.`,
  },
  {
    title: 'چرا آگهی‌ها نیاز به تاییدیه برای انتشار دارند؟',
    description: `ما موظفیم مطمئن شویم که آگهی‌های منتشر شده در فروشگاه مزرعه با موازین قانونی مغایرتی نداشته باشد تا محیطی
مناسب برای انجام معاملات مختلف در حوزه کشاورزی شکل گیرد.`,
  },
  {
    title: `چرا آگهی من رد شده است؟`,
    description: `کارشناسان پشتیبانی ما تشخیص داده‌اند در متن یا عکس آگهی شما مغایرتی با قوانین و مقررات فروشگاه وجود داشته
است یا کالای ثبت شده در آگهی شما مناسب با دسته‌بندی انتخاب شده نبوده است برای همین وضعیت آگهی شما به رد شده
تغییر یافته است.`,
  },
  {
    title: `فروشگاه مزرعه چه منافعی در معاملات خواهد داشت؟`,
    description: `فروشگاه هیچ نفعی از معاملات شما نخواهد داشت و فقط محیطی برای انتشار آگهی و ثبت نیازمندی است به همین خاطر
مسئولیتی در قبال معاملات انجام شده نخواهد داشت و از کاربران درخواست می‌شود قبل و هنگام معامله قوانین و
مقرارت فروشگاه را مطالعه کنند.`,
  },
  {
    title: `برای ثبت آگهی باید هزینه‌ای پرداخت کنم؟`,
    description: `خیر ثبت آگهی کاملا رایگان است ولی شما با خرید بسته‌های ارتقا آگهی می‌توانید به دیده شدن و فروش بیشتر دست یابید.`,
  },
  {
    title: `چرا من نمی‌توانم آگهی جدید ثبت کنم؟`,
    description: `طبق گزارش‌های کاربران و جمع‌بندی کارشناسان، ما به این نتیجه رسیده‌ایم تا تعیین تکلیف شکایات و نظرات ثبت شده،
فعالیت شما در فروشگاه مزرعه تعلیق شود.`,
  },
  {
    title: `فروشگاه مزرعه چه مزیتی برای کسب و کار من دارد؟`,
    description: `شما چه کشاورز باشید چه تامین کننده کالا و خدمات، این سامانه بستری تخصصی برای فعالیت‌های شماست، به دلیل آن
که فناوری‌های بکار رفته در فروشگاه مزرعه، نیازمندی‌های کشاورزان را بطور هوشمند به عرضه کنندگان معتبر
مرتبط می‌سازد.`,
  },
  {
    title: `اگر سوالی داشته باشم چطور بپرسم؟`,
    description: `شما می‌توانید در بخش ارتباط با ما هر ساعت از شبانه روز در پیام رسان‌های مختلف با کارشناسان تیم پشتیبانی در
ارتباط باشید و سوال، مشکل یا خطاهای بوجود آمده در فروشگاه را با ما در میان گذارید.`,
  },
];

const Faq = () => {
  const [activeKey, setActiveKey] = useState<string | undefined>('0');

  return (
    <>
      <Header title="سوالات متداول" />
      <div className="px-2">
        <Accordion
          activeKey={activeKey}
          onSelect={(e: AccordionEventKey) => setActiveKey(e?.toString())}
        >
          {React.Children.toArray(
            Faqs.map((item, index) => (
              <FaqItem
                faq={item}
                index={index.toString()}
                activeKey={activeKey}
              />
            )),
          )}
        </Accordion>
      </div>
    </>
  );
};

export default Faq;
